import React, { useContext } from "react";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import { HotelOwnerContext } from "./HotelOwnerContext";
export default function HotelOwnerAccount(){
    const {hotelOnwerData}=useContext(HotelOwnerContext)
    return (
        <div>
           <div className=" flex flex-row max-w-full min-w-fit gap-x-4 mb-4">
            <Link to="change" className=" flex flec-col hover:text-blue-500">
              <FontAwesomeIcon icon={faTachometerAlt} className=" w-12 h-12 hover:text-blue-500"/>account
             </Link>
             <Link to="logout">
               <FontAwesomeIcon icon={faSignOut} className=" w-12 h-12 hover:text-blue-500"/>change
             </Link>            
            </div>
            <div className=" flex flex-col ">
              {hotelOnwerData?.profile?<img src={hotelOnwerData?.profile} className=" w-12 h-12 rounded-full"/>:<FontAwesomeIcon className=" w-12 h-12 rounded-full" icon={faUser} />}
               <p>Username :{hotelOnwerData?.username}</p>
               <p>Useremail :{hotelOnwerData?.email}</p>
               <p>name :{hotelOnwerData?.name}</p>
              </div>
              
             <Outlet/>
                
        </div>
    )
}